import * as Sentry from "@sentry/react";
import { getErrorMonitoringDsn } from "util/util";

const errorMonitoringDsn = getErrorMonitoringDsn();
if (errorMonitoringDsn) {
    Sentry.init({
        dsn: errorMonitoringDsn,

        // Adds request headers and IP for users, for more info visit:
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
        sendDefaultPii: false,

        // Capture all errors, including unhandled promise rejections
        attachStacktrace: true,
        
        // Capture errors from all sources
        beforeSend(event) {
            // You can filter events here if needed
            return event;
        },

        // Capture unhandled promise rejections
        integrations: [
        ],

        // Set the environment
        environment: process.env.NODE_ENV || 'development',

        // Capture console errors
        debug: process.env.NODE_ENV === 'development',
    });

    // Capture unhandled promise rejections
    window.addEventListener('unhandledrejection', (event) => {
        Sentry.captureException(event.reason);
    });

    // Capture console errors
    const originalConsoleError = console.error;
    console.error = (...args) => {
        Sentry.captureException(new Error(args.join(' ')));
        originalConsoleError.apply(console, args);
    };
}
